import { Space } from "antd";
import { DAYS } from "../../constants/date";
import useAvailabilities from "./useAvailabilities";
import AvailabilityDay from "./availabilityDay";

const Availabilities = () => {
  const { values } = useAvailabilities();

  return (
    <Space direction="vertical" size={16} style={{ width: "100%" }}>
      {DAYS.map((item) => (
        <AvailabilityDay key={item.name} item={item} values={values} />
      ))}
    </Space>
  );
};

export default Availabilities;
